import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { UserService } from "@publicPortal/services/UserService";
import { useState } from "react";
import ResetPasswordBoilerplate from "@mirage/components/resetPassword/ResetPasswordBoilerplate";

const ResetPassword = () => {
    const [resultBoard, setResultBoard] = useState({ show: false, message: "", success: true, isLoading: false });
    const userService = new UserService();
    const pp = new PublicPortalRoutingService();

    const getResultBoard = () => {
        return (
            <ResultBoard
                success={resultBoard.success}
                loading={false}
                headerText="Reset password"
                buttonLabel="Sign in"
                buttonNavTo={pp.LoginRoute()}
                message={resultBoard.message}
            />
        );
    };

    return (
        <>
            <BigLogo />
            {resultBoard.show ? (
                getResultBoard()
            ) : (
                <Board headerText="Reset password" size="small">
                    <ResetPasswordBoilerplate service={userService} backButtonRoute={pp.ForgotPasswordRoute()} setResultBoard={setResultBoard} />
                </Board>
            )}
        </>
    );
};

export default ResetPassword;
